import {
    SET_CURRENT_USER
} from "./UserType";

const initialState = {
    currentUser: {}
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_CURRENT_USER:
            return {
                ...state, currentUser: action.value
            }
        default:
            return state;
    }
};

export default reducer;
